<template>
    <div id="drop-area">

        <div v-if="attachments.length > 0" class="my-2 d-flex flex-wrap">
            <div v-for="attachment in attachments" class="ms-1 d-flex flex-row">
                <a :href="attachment.url" target="_blank">
                    <img v-if="isImage(attachment)" :src="attachment.url" width="200">
                    <span v-else-if="attachment.file_type === 'application/pdf'"
                          data-bs-toggle="tooltip" data-placement="top" :title="attachment.name">
                        <i class="fas fa-file-pdf"></i>
                    </span>
                    <span v-else>{{attachment.name}}</span>
                </a>
                <i class="fas fa-times pointer ms-1" @click="onRemoveClick(attachment)"></i>
            </div>

        </div>

        <div class="mb-3 ms-1 pointer">
            <input class="form-control" type="file" id="fileElem" multiple @change="handleFileSelect">
        </div>

    </div>
</template>

<script>

    import ModelService from "../../services/ModelService";
    import AttachmentService from "../../services/AttachmentService";
    import AttachmentViewer from "../controls/AttachmentViewer.vue";
    import TableUtil from "../../utils/TableUtil";

    export default {
        name: 'AttachmentEditor',
        components: {AttachmentViewer},
        props: ['table', 'field', 'document'],

        data() {
            return {
                model: webase.model,
                dropArea: null,
                uploadProgress: [],
                modelService: new ModelService(),
                defaultDragEvents: ['dragenter', 'dragover', 'dragleave', 'drop'],
                hoverDragEvents: ['dragenter', 'dragover'],
                dragEvents: ['dragleave', 'drop'],
                highlightEnabled: false,
                attachments: this.document[this.field.index] ? this.document[this.field.index] : []
            }
        },
        mounted() {
            this.dropArea = document.getElementById("drop-area")

            // Prevent default drag behaviors
            this.defaultDragEvents.forEach(eventName => {
                this.dropArea.addEventListener(eventName, this.preventDefaults, false)
                document.body.addEventListener(eventName, this.preventDefaults, false)
            })

            // Highlight drop area when item is dragged over it
            this.hoverDragEvents.forEach(eventName => {
                this.dropArea.addEventListener(eventName, this.highlight, false)
            })

            this.dragEvents.forEach(eventName => {
                this.dropArea.addEventListener(eventName, this.unhighlight, false)
            })

            // Handle dropped files
            this.dropArea.addEventListener('drop', this.handleDrop, false)
        },
        methods: {

            preventDefaults(e) {
                e.preventDefault()
                e.stopPropagation()
            },

            highlight(e) {
                this.highlightEnabled = true
            },

            unhighlight(e) {
                this.highlightEnabled = false
            },

            handleDrop(e) {
                let dataTransfer = e.dataTransfer
                let files = dataTransfer.files
                this.handleFiles(files)
            },

            handleFileSelect(event){
                let files = event.target.files
                this.handleFiles(files)
            },

            handleFiles(files) {
                try {
                    files = [...files]
                    files.forEach(this.uploadFile)
                }
                catch(error) {
                    console.log('file handler error')
                    console.log(error)
                    console.log(files)
                }
            },

            uploadFile(file, i) {
                let appId = this.table.app_id
                let service = new AttachmentService()
                service.saveAttachment(appId, this.field.index, this.document['id'], file).then( (response) => {
                    this.attachments.push(response)
                })
            },
            isImage(attachment) {
                let tableUtil = new TableUtil()
                return tableUtil.isImage(attachment)
            },
            onRemoveClick(attachment) {

                for (let i = 0; i < this.attachments.length; i++) {
                    let currentAttachment = this.attachments[i]

                    if (currentAttachment.attachment_id === attachment.attachment_id) {

                        let service = new AttachmentService()
                        service.remove(attachment.attachment_id).then( () => {
                            console.log('Attachment removed')
                            this.attachments.splice(i, 1)
                        })

                        break
                    }
                }
            }
        }
    }
</script>